// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  brandHome: 'Spatius home',
  accountAccess: 'Account access',
  backToSite: 'Back to spatius.ai',
  selectLanguage: 'Select language',
  story: {
    title: 'Next-Gen Digital Human.',
    subtitle: 'Alive. Accessible. Affordable. $0.42 per hour, quick start in 10 minutes.',
  },
  fields: {
    email: 'Email',
    password: 'Password',
    name: 'Your name',
    choosePassword: 'Choose a password',
    confirmPassword: 'Confirm password',
    newPassword: 'New password',
    passwordMin: 'At least 8 characters',
    passwordRepeat: 'Re-enter password',
  },
  passcodeGroup: 'Six-digit verification code',
  passcodeDigit: 'Passcode digit {index}',
}

export const zhCN = {
  brandHome: 'Spatius 首页',
  accountAccess: '账户登录',
  backToSite: '返回 spatius.ai',
  selectLanguage: '选择语言',
  story: {
    title: '下一代数字人。',
    subtitle: '鲜活 · 易用 · 可负担。每小时 $0.42，10 分钟快速开始。',
  },
  fields: {
    email: '邮箱',
    password: '密码',
    name: '你的名字',
    choosePassword: '设置密码',
    confirmPassword: '确认密码',
    newPassword: '新密码',
    passwordMin: '至少 8 位',
    passwordRepeat: '请再次输入密码',
  },
  passcodeGroup: '六位验证码',
  passcodeDigit: '验证码第 {index} 位',
}
